import {EndoMultiToothExamSurfaceAutofillDetailConfigurationModel} from './endo-multi-tooth-exam-surface-autofill-detail-configuration.model';

export class EndoMultiToothExamSurfaceAutofillConfigurationModel {
  SurfaceAutofillID: string;
  ToothID: string;

  cfgEndoMultiToothExamSurfaceAutofillDetails: EndoMultiToothExamSurfaceAutofillDetailConfigurationModel[] = [];
}
